import { WorldMapView } from '@/components/game/WorldMap';

export function MapPage() {
  return <WorldMapView />;
}
